<template>
  <div id="section7" class="page-section7">
    <div class="s7-header fade-on-scroll">
      <div class="s7-header-top">
        <svg class="s7-quote-mark" aria-hidden="true" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
          <path d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"/>
        </svg>
        <span class="s7-divider-line"></span>
      </div>
      <h2 class="s7-title">Our Gallery</h2>
    </div>

    <div class="s7-grid">
      <div
        v-for="(item, index) in galleryItems"
        :key="item.id || index"
        class="gallery-item fade-on-scroll"
        @click="openLightbox(index)"
      >
        <img :src="getGalleryUrl(item.file)" loading="lazy" :alt="`Gallery ${index + 1}`">
        <div class="gallery-overlay">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- Custom Native Lightbox (SSR-safe, no external ESM dependency) -->
    <Teleport to="body">
      <transition name="lightbox-fade">
        <div v-if="lightboxVisible && galleryItems.length > 0" class="custom-lightbox" @click.self="closeLightbox">
          <button type="button" class="lb-close" @click="closeLightbox" aria-label="Tutup galeri">&times;</button>
          <button type="button" class="lb-prev" @click="prevPhoto" :disabled="galleryItems.length < 2" aria-label="Foto sebelumnya">&#8249;</button>
          <img
            v-if="galleryItems[lightboxIndex]"
            :src="getGalleryUrl(galleryItems[lightboxIndex].file)"
            :alt="`Wedding photo ${lightboxIndex + 1}`"
            class="lb-img"
          />
          <button type="button" class="lb-next" @click="nextPhoto" :disabled="galleryItems.length < 2" aria-label="Foto berikutnya">&#8250;</button>
          <div class="lb-counter">{{ lightboxIndex + 1 }} / {{ galleryItems.length }}</div>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useInvitationStore } from '@/store';
// vue-easy-lightbox removed — using custom native lightbox (SSR-safe)

export default {
  name: 'GallerySection',
  data() {
    return {
      lightboxVisible: false,
      lightboxIndex: 0,
    };
  },
  computed: {
    ...mapState(useInvitationStore, ['gallery']),
    galleryItems() {
      return this.gallery.length ? this.gallery : [];
    },
  },
  watch: {
    galleryItems(val) {
      if (val && val.length) {
        this.$nextTick(() => this.setupFadeObserver());
      }
    },
  },
  mounted() {
    this.setupFadeObserver();
    this._onKeydown = (e) => this.onKeydown(e);
    window.addEventListener('keydown', this._onKeydown);
  },
  beforeUnmount() {
    if (this._fadeObserver) this._fadeObserver.disconnect();
    window.removeEventListener('keydown', this._onKeydown);
  },
  methods: {
    getGalleryUrl(file) {
      return `https://admin.itsyourdayofficial.com/gallery/${encodeURIComponent(file)}`;
    },
    openLightbox(index) {
      this.lightboxIndex = index;
      this.lightboxVisible = true;
      if (typeof document !== 'undefined' && document.body) document.body.style.overflow = 'hidden';
    },
    closeLightbox() {
      this.lightboxVisible = false;
      if (typeof document !== 'undefined' && document.body) document.body.style.overflow = '';
    },
    prevPhoto() {
      if (this.galleryItems.length < 2) return;
      this.lightboxIndex = (this.lightboxIndex - 1 + this.galleryItems.length) % this.galleryItems.length;
    },
    nextPhoto() {
      if (this.galleryItems.length < 2) return;
      this.lightboxIndex = (this.lightboxIndex + 1) % this.galleryItems.length;
    },
    onKeydown(event) {
      if (!this.lightboxVisible) return;
      if (event.key === 'Escape') this.closeLightbox();
      else if (event.key === 'ArrowLeft') this.prevPhoto();
      else if (event.key === 'ArrowRight') this.nextPhoto();
    },
    setupFadeObserver() {
      if (this._fadeObserver) this._fadeObserver.disconnect();
      if (typeof IntersectionObserver === 'undefined') {
        // Fallback: langsung tampilkan semua
        this.$el.querySelectorAll('.fade-on-scroll').forEach(el => el.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); }),
        { threshold: 0.05 }
      );
      this.$el.querySelectorAll('.fade-on-scroll').forEach(el => observer.observe(el));
      this._fadeObserver = observer;
    },
  },
};

</script>

<style scoped>
.fade-on-scroll { opacity: 0; transform: translateY(40px); transition: opacity 1s ease-out, transform 1s ease-out; }
.fade-on-scroll.is-visible { opacity: 1; transform: translateY(0); }

.page-section7 { background-color: #f9f9f9; padding: 4rem 1.2rem 5rem; }
.s7-header { margin-bottom: 2rem; padding: 0 0.5rem; }
.s7-header-top { display: flex; align-items: center; gap: 16px; margin-bottom: 0.6rem; }
.s7-quote-mark { width: 42px; height: 42px; fill: #4a5c74; flex-shrink: 0; opacity: 0.8; }
.s7-divider-line { flex: 1; height: 1.5px; background: #4a5c74; opacity: 0.7; }
.s7-title { font-family: 'Great Vibes', cursive; font-size: 3.5rem; font-weight: normal; color: #2c3e50; text-align: right; line-height: 1.2; }
.s7-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4px; }
.gallery-item { position: relative; overflow: hidden; cursor: pointer; aspect-ratio: 3/4; }
.gallery-item img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.4s ease; display: block; }
.gallery-item:hover img { transform: scale(1.06); }
.gallery-overlay {
  position: absolute; inset: 0; background: rgba(0,0,0,0.45);
  display: flex; align-items: center; justify-content: center; opacity: 0; transition: opacity 0.3s ease;
}
.gallery-item:hover .gallery-overlay { opacity: 1; }
.gallery-overlay svg { width: 40px; height: 40px; color: #ffffff; filter: drop-shadow(0 2px 6px rgba(0,0,0,0.5)); }

/* Custom Lightbox */
.lightbox-fade-enter-active, .lightbox-fade-leave-active { transition: opacity 0.2s ease; }
.lightbox-fade-enter-from, .lightbox-fade-leave-to { opacity: 0; }

.custom-lightbox {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(0,0,0,0.92);
  display: flex; align-items: center; justify-content: center;
  padding: 24px;
}
.lb-img { max-width: 92vw; max-height: 88vh; object-fit: contain; box-shadow: 0 20px 80px rgba(0,0,0,0.45); border-radius: 4px; }
.lb-close {
  position: absolute; top: 16px; right: 20px;
  background: transparent; border: none; color: #fff;
  font-size: 40px; cursor: pointer; line-height: 1; z-index: 1;
  opacity: 0.85; transition: opacity 0.2s;
}
.lb-close:hover { opacity: 1; }
.lb-prev, .lb-next {
  position: absolute; top: 50%; transform: translateY(-50%);
  background: rgba(255,255,255,0.15); border: none; color: #fff;
  font-size: 40px; padding: 8px 14px; cursor: pointer;
  border-radius: 4px; transition: background 0.2s;
}
.lb-prev:hover, .lb-next:hover { background: rgba(255,255,255,0.3); }
.lb-prev:disabled, .lb-next:disabled { opacity: 0.3; cursor: default; }
.lb-prev { left: 12px; }
.lb-next { right: 12px; }
.lb-counter {
  position: absolute; bottom: 16px; left: 50%; transform: translateX(-50%);
  color: rgba(255,255,255,0.7); font-size: 0.9rem; font-family: 'Cinzel', serif; letter-spacing: 1px;
}
</style>
